import { defineStore } from 'pinia';
import { LOGIN, GET_USERINFO } from '@/api';
import verConfig from "@/utils/config";
import { getStorage, setStorage, setToken, deleteToken, removeStorage } from "@/utils";
import router from "@/router"
import { useCoinStore } from "./coin";

const state = () => ({
  data: getStorage('userInfo') ? JSON.parse(getStorage('userInfo') || '{}') : {},
  _bankList: [],
  assetList: {},
  _balance: "0.00",
  _rateType: verConfig.rateType || 'USDT',
  _selectAccount: 0,
})

export const useUserStore = defineStore('user', {
  state,
  getters: {
    userInfo() {
      return this.data;
    },
  },
  actions: {
    login(params) {
      return new Promise(async (resolve, reject) => {
        const coinStore = useCoinStore();
        try {
          const { data, msg } = await LOGIN(params);
          setToken(data.token);
          setStorage('userInfo', JSON.stringify(data));
          this.data = { ...data };
          coinStore.getAssetslist()
          resolve({ data, msg })
        } catch (error) {
          reject(error)
        }
      })
    },
    logout(flag = false) {
      deleteToken();
      removeStorage('userInfo')
      this.data = {};
      this._bankList = [];
      this.assetList = {};
      this._balance = "0.00";
      if (!flag) {
        router.push('/')
      }
    },
    setUserInfo(params) {
      this.data = { ...params }
    },
    getUserInfo() {
      return new Promise(async (resolve, reject) => {
        try {
          const { data } = await GET_USERINFO();
          this.data = { ...data };
          setToken(data.token);
          setStorage('userInfo', JSON.stringify(data));
          resolve({ ...data })
        } catch (error) {
          reject(error)
        }
      })
    },
  }
})